import React from 'react';
import css from '../ListingPage.css';
import { NoResultsBlock } from '../../../components';
import PageLayout from '../components/PageLayout';

export default ({ intl, scrollingDisabled, appIsMounted, noIndexTag }) => {
    // 404 listing not found

    const notFoundTitle = intl.formatMessage({
        id: 'ListingPage.notFoundListingTitle',
    });

    return (
        <PageLayout
            showTopBar={appIsMounted}
            title={notFoundTitle}
            scrollingDisabled={scrollingDisabled}
            metaTags={noIndexTag}
            blobBackground
        >
            <div className={css.noResultsContainer}>
                <NoResultsBlock
                    headerId="Dieses Profil existiert nicht mehr."
                    parapraphId="Das aufgerufene Profil wurde gelöscht und existiert nicht mehr."
                    searchFormPlaceholder="Suche in deiner Nähe"
                    isSearchForm
                    rootClass={css.noResultsBlock}
                />
            </div>
        </PageLayout>
    );
};
